export default __webpack_public_path__ + "static/media/11_photo.27d4a691.jpg";